function Footer() {
    return (
      <div
        className="bg-mapua-blue text-white text-center p-4 w-full bottom-0">
        <p>© 2024 PROJECT LAWA</p>
      </div>
    );
}

export default Footer;
